export const magdalenaWaszak = {
    'meta': {
        'title': 'Psycholog Magdalena Waszak • Centrum COLLIGO',
        'description': 'Jestem psychologiem z 17-letnim stażem pracy, trenerem rozwoju osobistego oraz coachem. Pracuję w nurcie Racjonalnej Terapii Zachowań.'
    },
    'url': {
        'address': '/bydgoszcz/zespol/psycholog-magdalena-waszak/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/magdalena-waszak.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog w Bydgoszczy Magdalena Waszak'
        }
    }
}